import React, { useState, useEffect } from "react";
import { getAllPeople } from "../../../api/people";
import { People } from "../../../compilers/people";
import PeopleCard from "../../people/PeopleCard";
import Skeleton from "react-loading-skeleton";
// import PeopleCardSkeleton from '../../people/PeopleCardSkeleton';
import YellowDivider from "../../dividers/YellowDivider";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import Button from "../../singlecomponents/Button";
import "../../../stylesheet/components/about/zepeople/ZePeople.scss";

const ZePeople: React.FC = () => {
  const [people, setPeopleContent] = useState<People[]>();
  const { i18n, ready, t } = useTranslation();
  const SliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
    ],
  };

  useEffect(() => {
    //console.log("Calling people");
    //if (ready) {
    setPeopleContent(undefined);
    getAllPeople("en").then((response: People[]) => {
      //console.log("people", response);
      if (response) {
        setPeopleContent(response.sort(() => 0.5 - Math.random()).slice(0, 4));
      }
    });
    //  }
  }, [i18n.language]);

  const getBody = () => {
    if (ready) {
      return t("about-zefi.ze-people.body");
    }
    return (
      <div>
        <Skeleton width={500} />
        <Skeleton width={500} />
        <Skeleton width={500} />
        <Skeleton width={500} />
        <Skeleton width={500} />
        <Skeleton width={500} />
      </div>
    );
  };

  const getPerson = () => {
    if (people) {
      return people.map((person) => {
        //console.log(person);
        return <PeopleCard key={person.id} media={person} />;
      });
    }
  };

  return (
    <div className="container my-4">
      <div className="info-section__info-wrapper section-divider ze-people-container">
        <div className="col-12 col-lg-9 px-0">
          <div className="mb-3 mb-lg-4">
            <h2>
              {ready ? (
                t("about-zefi.ze-people.title")
              ) : (
                <Skeleton width={350} />
              )}
            </h2>
            <YellowDivider heading="h2" />
          </div>
          <div className="mx-xl-5 mt-3">
            <div className="mx-2 p3">{getBody()}</div>
          </div>
        </div>
        <div className="mobile-move-to-bottom mt-3">
          <Link to={`/${i18n.language}/people`}>
            <Button
              name={t("ze-people.heading.cta-button")}
              buttonWhite={true}
            />
          </Link>
        </div>
        <div className="ze-people-slider">
          <Slider {...SliderSettings}>{getPerson()}</Slider>
        </div>
      </div>
    </div>
  );
};

export default ZePeople;
